import React from 'react';
import styles from './Loader.scss';
import { number, string } from 'prop-types';

export default function Loader({ className, size, width }) {
  const style = {
    width: size,
    height: size,
    borderWidth: width,
    borderLeftWidth: width,
  };

  return <div className={`${className} ${styles.loader}`} style={style} />;
}

Loader.displayName = 'Loader';
Loader.propTypes = {
  size: number,
  width: number,
  className: string,
};

Loader.defaultProps = {
  size: 20,
  width: 3,
};
